export const colors = [
  "#fc3957",
  "#fb6fc8",
  "#fbee06",
  "#4dc83d",
  "#329ff2",
  "#783cfb",
  "#f9f9f9",
  "#292935"
];
